/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { onboardingRepository } from '../repositories'
import { useAppSelector } from '../store/hooks'

function useProgressStudent() {
	const {
		matriculate: { classSelect },
		auth: { user },
	} = useAppSelector((state) => state)

	const [_progress, { isLoading, isSuccess }] =
		onboardingRepository.useProgressStudentMutation()

	async function execute(
		{
			step,
			curso_id,
			proficiencia_id,
			skip = false,
		}: {
			step: number
			curso_id?: number
			proficiencia_id?: number
			skip?: boolean
		},
		onSuccess?: () => void
	) {
		if (!user?.id || !classSelect?.curso_id) return

		await _progress({
			id: user.id,
			curso_id,
			proficiencia_id,
			step: step,
			skip,
		})
			.then(() => {
				if (onSuccess) onSuccess()
			})
			.catch((error) => {
				console.error(error)
			})
	}

	return { execute, isLoading, isSuccess }
}

export default {
	progressStudent: useProgressStudent,
}
